import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Warband from "./Warband";

import FramePanelContent from "../../../ui/containers/FramePanelContent";
import NewWarbandButton from "./NewWarbandButton";
import NewAvatarButton from "./NewAvatarButton";
import ListEntryButton from "../../list-entry/ListEntryButton";


function ListPanelContent({ faction, parsedList }) {
	const { children } = parsedList;
	const warbands = children.filter(c => c.type === "warband");
	const avatars = children.filter(c => c.type === "avatar");
	const countWarbands = warbands.length;

	return (
		<FramePanelContent>
			<Stack spacing={5}>
				{warbands.map(w => <Warband key={w.id} warbandNode={w} faction={faction} />)}
				<NewWarbandButton faction={faction} countWarbands={countWarbands} />
				{avatars.map(a => <ListEntryButton key={a.id} node={a} factionSlug={faction.slug}/>)}
				{countWarbands > 0 && <NewAvatarButton faction={faction} existingAvatars={avatars} />}
			</Stack>
		</FramePanelContent>
	);
}


export default ListPanelContent;